// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"96":"16d32794","216":"22b45510","261":"a2f7c6c6","550":"d1a196f4","682":"58d1f36b","788":"051c1749","819":"632606aa"}[chunkId] + ".chunk.css";
};